import { chartColors } from 'theme/palette';

export const getDataItemColor = (idx: number): string => {
  return chartColors[(idx % chartColors.length)]
}